import { SHOW_SITE_MODAL, SITE_DETAIL } from './actionType';

export const toggleSiteModel = (isShow, share_card_id, isAction, from_user_email) => dispatch => {
  dispatch({ type: SHOW_SITE_MODAL, payload: { isShow, share_card_id, isAction, from_user_email } });
  !isShow && dispatch({ type: SITE_DETAIL, payload: [] });
};
